<div [formGroup]="this.formGroup">
  <app-dropdown-field
          [label]='this.label'
          [id]="this.propertyId"
          [propertyName]="this.propertyName"
          [formGroup]="this.formGroup"
          [optional]=true
          [dropdownData]="[
                            { code: '', display: ' -- Select -- ', value: '' },
                            { code: 'MR', display: 'Mr.', value: 'MR' },
                            { code: 'MRS', display: 'Mrs.', value: 'MRS' },
                            { code: 'MIS', display: 'Miss.', value: 'MIS' },
                            { code: 'MS', display: 'Ms.', value: 'MS' },
                            { code: 'DR', display: 'Dr.', value: 'DR' } ]">
  </app-dropdown-field>
</div>